/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_DescriptionInputs */

const en_site_description = /** @type {(inputs: Site_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interactive Open RMF demo: 3D visualization of multi-fleet orchestration in your browser, no Gazebo or local install required.`)
};

const fr_site_description = /** @type {(inputs: Site_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démo interactive d'Open RMF : visualisation 3D d'orchestration multi-flottes dans le navigateur, sans Gazebo ni installation locale.`)
};

const ms_sg2_site_description = /** @type {(inputs: Site_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demo interaktif Open RMF: visualisasi 3D orkestrasi pelbagai armada robot dalam pelayar anda, tanpa Gazebo atau pemasangan tempatan.`)
};

/**
* | output |
* | --- |
* | "Interactive Open RMF demo: 3D visualization of multi-fleet orchestration in your browser, no Gazebo or local install required." |
*
* @param {Site_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const site_description = /** @type {((inputs?: Site_DescriptionInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_DescriptionInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_site_description(inputs)
	if (locale === "fr") return fr_site_description(inputs)
	return ms_sg2_site_description(inputs)
});